export default "__VITE_ASSET__CRR_yTbZ__"